import { Bogle_Regular } from 'constants/constant';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
const { GREY } = colors;

const slaStyles = makeStyles(() => ({
	text: {
		font: `14px /1.4 ${Bogle_Regular}`,
		height: '100%',
		textAlign: 'left',
		color: GREY
	},
	parent: {
		display: 'inline-block',
		padding: '8px 16px 0px 16px'
	},
	sup: {
		verticalAlign: 'bottom'
	}
}));

export default slaStyles;
